import '../css/footbar.css';

function FootBar() {
  return (
    <div className="footbar">
        <p>2023 &copy; Azpira. All rights reserved.</p>
    </div>
  );
}

export default FootBar;
